import { LOADING_UPDATE_ADD_VOUCHER_WIRE, NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE, RESET_UPDATE_ADD_VOUCHER_WIRE, UPDATE_ADD_VOUCHER_WIRE_FAILED, UPDATE_ADD_VOUCHER_WIRE_SUCCESS } from "../types"

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: '',
    networkError: '', 
}

export const updateOrAddVoucherWire = ( state = initialState, { type, payload } ) => {
    switch( type ) {
        case LOADING_UPDATE_ADD_VOUCHER_WIRE: {
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: '',
                networkError: '',
            }
        }            
        case UPDATE_ADD_VOUCHER_WIRE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        }            
        case UPDATE_ADD_VOUCHER_WIRE_FAILED: {
            return {
                ...state, 
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: payload,
                message: '',
                networkError: '',
            }
        }
        case NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE: {
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: payload,
                message: "",
                networkError: "",
            }
        }
        case RESET_UPDATE_ADD_VOUCHER_WIRE:{
            return ( state = initialState );
        }            
        default: 
            return state;
    }
}